import { ValidationObserver, ValidationProvider } from "vee-validate";
import moment from "moment";
import { Calendar } from "@/models/calendar/Calendar";
import { EventsTypes } from "@/enums/EventsTypes";
import imageToBase64 from 'image-to-base64/browser';
import html2canvas from "html2canvas";
import * as firebase from "firebase";
import JSZip from "jszip";
import { ServiceRequest } from "@/models/ServiceRequest";
import { ServiceStatus } from "@/enums/ServiceStatus";

export default {
  name: 'MemberDownload',
  components: {
    ValidationObserver,
    ValidationProvider
  },
  data() {
    return {
      dialogDownload: false,
      member: null,
      family: [],
      email: '',
      focus: '',
      type: "month",
      title: '',
      mode: '',
      isLoading: false,
      filters: [
        EventsTypes.ConciergeRequest,
        EventsTypes.LifestylePrograms,
        EventsTypes.PremiumServices,
        EventsTypes.Notice
      ],
      archiveId: '',
      archiveMetaData: null,
      archivePath: '',
      archiveContent: null,
      attachmentsArr: [],
    }
  },
  methods: {
    open(member, family, mode) {
      this.dialogDownload = true;
      this.member = member;
      this.family = family;
      this.mode = mode;
      const duration = 90;

      if (this.mode === "resident") {
        const residentId = member.id;
        this.$store.dispatch("getResidentMessages", { residentId, duration });
      } else {
        const familyId = member.id;
        this.$store.dispatch("getFamilyMessages", { familyId, duration });
      }
    },
    close() {
      this.isLoading = false;
      this.email = "";
      this.focus = "";
      this.$refs.residentDownloadForm.reset();
      this.$refs.observer.reset();
      this.dialogDownload = false
    },
    formatDate(a, withTime): string {
      return withTime
        ? `${a.getFullYear()}-${a.getMonth() +
        1}-${a.getDate()} ${a.getHours()}:${a.getMinutes()}`
        : `${a.getFullYear()}-${a.getMonth() + 1}-${a.getDate()}`;
    },
    getColor(type): string {
      if (type == EventsTypes.LifestylePrograms) return '#0D47A1';
      else if (type == EventsTypes.PremiumServices) return 'green';
      else if (type == EventsTypes.Notice) return 'red';
      else if (type == EventsTypes.FamilyVisit) return 'indigo';
      else if (type == EventsTypes.Medical) return 'pink';
      else if (type == EventsTypes.Concierge) return 'orange';
      return 'orange';
    },
    async downloadForm() {
      this.isLoading = true;

      await this.checkAvatar();

      if (this.mode === "resident") {

        await this.generateResidentCalendarScreenshots();

        await this.getResidentPhotos();

        await this.generateResidentProfile();

        if (this.residentMessagesMonth.length) {
          this.attachmentsArr.push({
            filename: `Messages_${this.member.name}.txt`,
            content: JSON.stringify(this.residentMessagesMonth, null, 1).replace(/{|},|}|[|]|"/gi, '')
          })
        }
      } else {

        await this.getFamilyMemberPhotos();

        await this.generateFamilyMemberProfile();

        if (this.familyMessages.length) {
          this.attachmentsArr.push({
            filename: `Messages_${this.member.name}.txt`,
            content: JSON.stringify(this.familyMessages, null, 1).replace(/{|},|}|[|]|"/gi, '')
          })
        }
      }

      await this.checkFiles();

      await this.generateArchive();

      await this.saveDownloadToFirestore();

      await this.saveDownloadsToStorage();

      await this.getArchivePath();

      await this.addPathToDownload();

      console.log("sendArchiveProfile")
      console.log(this.archivePath)

      await this.$store.dispatch("sendArchiveProfile", {
        email: this.email,
        name: this.member.name,
        attachments: {
          path: this.archivePath
        }
      })

      this.close();
    },
    async checkAvatar() {
      try {
        const avatar = this.member.imageUrl;

        if (avatar && !avatar.includes("no-avatar") && !avatar.includes("no-image")) {
          const avatarBase64 = await imageToBase64(avatar)
          this.attachmentsArr.push({
            filename: `Avatar_${this.member.name}.png`,
            content: avatarBase64,
            encoding: 'base64'
          })
        }
      } catch (error) {
        console.error(error)
      }
    },
    async generateResidentCalendarScreenshots() {

      try {
        for (let i = 0; i <= 2; i++) {
          const month = this.title;
          this.prev();
          const canvas = await html2canvas(document.querySelector('#resident-calendar'));
          const url = canvas.toDataURL();
          const report = url.replace("data:image/png;base64,", "")
          this.attachmentsArr.push({
            filename: `Report_${month}.png`,
            content: report,
            encoding: 'base64'
          })
        }
      } catch (error) {
        console.error(error)
      }


      return true;
    },
    async generateResidentProfile() {

      try {


        let familyMembers = "";
        if (this.family.length) {
          const familyMembersHead = `\nFamily And Friends`;
          const familyMembersList = this.family.map((member, index) => {
            return `
            \nPerson ${index + 1}
            \nName: ${member.name}
            \nEmail: ${member.email}
            \nPhone: ${member.phoneNumber}
            \nRelationship: ${member.relationship} \n`
          });
          familyMembers = familyMembersHead + familyMembersList;
        }

        let residentServiceRequests = "";
        if (this.currentResidentServiceRequests.length) {
          const residentServiceRequestsHead = `\nPremium Service Requests \n \nService  Type  Status`;
          const residentServiceRequestsList = this.currentResidentServiceRequests.map(service => {
            return `\n\n${service.serviceName} ${service.serviceType} ${service.status}`
          });
          residentServiceRequests = residentServiceRequestsHead + residentServiceRequestsList
        }

        let notifications = `\nRecent Notifications\n`;
        if (this.notificationsResident.length) {
          const notificationsHead = `\nType  Title  Content`;
          const notificationsList = this.notificationsResident.map((notification) => {
            return `\n\n${notification.type}  ${notification.title}  ${notification.body ? notification.body : notification.title} ${moment(notification.dateTimeUpdated.seconds * 1000).format("DD MMM, h:mm a")}`
          });
          notifications = notifications + notificationsHead + notificationsList;
        } else {
          const notificationsContent = "\nNo data available";
          notifications = notifications + notificationsContent;
        }

        const residentStory = `\nMy Story \n \n${this.member.aboutMe ? this.member.aboutMe : "No story recorded."}`;

        const residentPreferences = `\nPreferences \n \n${this.member.preferences ? this.member.preferences : "No preferences."}`;

        this.attachmentsArr.push({
          filename: `Profile_${this.member.name}.txt`,
          content: `
          \nResident
          \nName: ${this.member.name}
          \nDOB: ${moment(this.member.dateOfBirth.seconds * 1000).format(this.facilityData.dateFormat)}
          \nWing Name: ${this.member.wingName}
          \nRoom Number: ${this.member.roomName}
          \nStatus: ${this.member.status}
          \n
          ${familyMembers}
          \n
          ${residentStory}
          \n
          ${residentPreferences}
          \n
          ${residentServiceRequests}
          \n
          ${notifications}
        `
        })

      } catch (error) {
        console.error(error)
      }
    },
    async getResidentPhotos() {

      try {


        for (let i = 0; i < this.residentPhotos.length; i++) {
          const photoBase64 = await imageToBase64(this.residentPhotos[i])
          this.attachmentsArr.push({
            filename: `Media_${i}.png`,
            content: photoBase64,
            encoding: 'base64'
          })
        }
      } catch (error) {
        console.error(error)
      }
      return true;
    },
    async generateFamilyMemberProfile() {

      try {


        const residents = this.family.map((resident, index) => {
          return `
            \nResident ${index + 1}
            \nName: ${resident.name}
            \nRelationship to resident: ${resident.familyHubUsers.find(x => x.id === this.member.id)?.relationship}
            \nFinancial EPOA: ${this.member.financialEPOA.find(x => x.id === resident.id)?.status ? "Yes" : "No"}
            \nRoom: ${resident.roomName, resident.wingName}
            \nDOB: ${moment(resident.dateOfBirth.seconds * 1000).format(this.facilityData.dateFormat)}
            \nStatus: ${resident.status}`
        });
        let notifications = "";
        if (this.notifications.length) {
          const notificationsHead = `
          \nNotifications
          \nType  Title  Content`;

          const notificationsList = this.notifications.map((notification) => {
            return `
            \n${notification.type}  ${notification.title}  ${notification.body ? notification.body : notification.title} ${moment(notification.dateTimeCreated.seconds * 1000).format("DD MMM, h:mm a")}`
          });

          notifications = notificationsHead + notificationsList;
        }
        this.attachmentsArr.push({
          filename: `Profile_${this.member.name}.txt`,
          content: `
            \nFamily Member
            \nName: ${this.member.name}
            \nStatus: ${this.member.status == 'Archived' ? "Archived" : "Active"}
            \nResident: ${this.member.residents[0].name}
            \nEmail: ${this.member.email}
            \nPhone: ${this.member.phoneNumber}
            \nFamily App Status: ${this.member.appStatus},
            \nLast Active On App: ${this.member.lastActive ? moment(this.member.lastActive.seconds * 1000).format("DD MMM, h:mm") : "Member didn`t activate app"}
            \nRecent Visits: ${this.$store.state.guestbookModule.familyHubMemberGuestbookVisits.length}
            \nRecent Video Calls: ${this.$store.state.calenderModule.familyHubMemberEvents.length}
            \nNumber of Messages sent: ${this.familyMessages.length}
            \n
            ${residents}
            \n
            ${notifications}
            `,
        });
      } catch (error) {
        console.error(error)
      }
    },
    async getFamilyMemberPhotos() {

      try {


        for (let i = 0; i < this.familyPhotos.length; i++) {
          const photoBase64 = await imageToBase64(this.familyPhotos[i])
          this.attachmentsArr.push({
            filename: `Media_${i}.png`,
            content: photoBase64,
            encoding: 'base64'
          })
        }

      } catch (error) {
        console.error(error)
      }

      return true;
    },
    async checkFiles() {
      if (!this.attachmentsArr.length) {
        this.$refs.provider.applyResult({
          errors: [`${this.member.name} hasn't any files`],
          valid: false,
        });
        this.isLoading = false;
        return false;
      }
    },
    async generateArchive() {

      try {


        const zip = new JSZip();
        this.attachmentsArr.forEach(item => {
          if (item.encoding) {
            zip.file(item.filename, item.content, { base64: true });
          } else {
            zip.file(item.filename, item.content);
          }
        });

        return zip.generateAsync({ type: "blob" })
          .then((blob) => {
            this.archiveContent = blob;
          });

      } catch (error) {
        console.error(error)
      }
    },
    async saveDownloadToFirestore() {
      const downloadData = {
        staffId: this.currentFacility,
        email: this.email,
        date: new Date(),
        residentId: null,
        familyMemberId: null
      }

      if (this.mode === "resident") {
        downloadData.residentId = this.member.id;
      } else {
        downloadData.familyMemberId = this.member.id;
      }

      return firebase
        .firestore()
        .collection("downloadsArchives")
        .add(downloadData)
        .then(data => {
          this.archiveId = data.id;
        });
    },
    async saveDownloadsToStorage() {
      const path = `${this.currentFacility}/downloadsArchives/${this.archiveId}`;

      return firebase
        .storage()
        .ref()
        .child(`${path}/archive.zip`)
        .put(this.archiveContent)
        .then((value) => {
          this.archiveMetaData = value;
        });
    },
    async getArchivePath() {
      return this.archiveMetaData.ref.getDownloadURL().then((value) => {
        this.archivePath = value;
      });
    },
    async addPathToDownload() {
      return firebase
        .firestore()
        .collection("downloadsArchives")
        .doc(this.archiveId)
        .update({
          path: this.archivePath
        });
    },
    prev(): void {
      this.$refs.calendarReport.prev();
    },
    changeCalendar() {
      this.title = this.$refs.calendarReport.title;
    },
    getResidentName(id) {
      const resident = this.residentsMembers.find(resident => resident.id === id);
      return resident ? resident.name : "Resident";
    },
    getFamilyMemberName(id) {
      const member = this.familyMembers.find(member => member.id === id);
      return member ? member.name : "Family member";
    },
  },
  computed: {
    residentMessagesMonth() {
      const arr = this.$store.state.messagesModule.residentMessagesMonth;
      return arr.map((item) => {
        return {
          from: item.from === "family" ? this.getFamilyMemberName(item.familyHubUserId) : this.getResidentName(item.residentId),
          to: item.to === "family" ? this.getFamilyMemberName(item.familyHubUserId) : this.getResidentName(item.residentId),
          text: item.text,
          date: moment(item.start).format("LLL"),
        }
      })
    },
    familyMessages() {
      const arr = this.$store.state.messagesModule.familyMessages;
      return arr.map((item) => {
        return {
          text: item.text,
          sender: item.from,
          date: moment(item.start).format("LLL"),
        }
      })
    },
    familyPhotos() {
      const arr = this.$store.state.messagesModule.familyMessages;
      const result = [];
      arr.forEach(item => {
        if (typeof item.image === "string") {
          result.push(item.image)
        }
      });
      return result;
    },
    residentPhotos() {
      const arr = this.$store.state.messagesModule.residentMessagesMonth;
      const result = [];
      arr.forEach(item => {
        if (typeof item.image === "string") {
          result.push(item.image)
        }
      });
      return result;
    },
    familyMembers() {
      return this.$store.state.residentModule.familyMembers;
    },
    residentsMembers() {
      return this.$store.state.residentModule.residentsShortData;
    },
    facilityData() {
      return this.$store.state.facilityModule.selectedFacility;
    },
    currentFacility() {
      return this.$store.state.authModule.currentFacility;
    },
    calendarEventsUpcoming(): Calendar[] {
      return this.$store.state.calenderModule.currentResidentsCalendarEvents;
    },
    calendarEventsPast(): Calendar[] {
      return this.$store.state.calenderModule.currentResidentCalendarEventsPast;
    },
    events() {
      const events = [...this.calendarEventsPast, ...this.calendarEventsUpcoming]
      const eventsResult = [];

      for (let i = 0; i < events.length; i++) {
        const dbEvt = events[i];
        eventsResult.push({
          name: dbEvt.name,
          id: dbEvt.id,
          imageUrl: dbEvt.imageUrl,
          attendees: dbEvt.attendees,
          attendeesIds: dbEvt.attendeesIds ? dbEvt.attendeesIds : [],
          description: dbEvt.description,
          isVirtualEvent: dbEvt.isVirtualEvent,
          going: dbEvt.going,
          notgoing: dbEvt.notgoing,
          goingLen: dbEvt.going?.length,
          notgoingLen: dbEvt.notgoing?.length,
          invitees: dbEvt.invitees,
          attendeesLen: dbEvt.invitees?.length,
          start: this.formatDate(dbEvt.start, true),
          end: this.formatDate(dbEvt.end, true),
          color: this.getColor(dbEvt.type),
          type: dbEvt.type,
        });
      }

      return eventsResult.filter(event => {
        if (
          event.type === EventsTypes.LifestylePrograms ||
          event.type === EventsTypes.PremiumServices ||
          event.type === EventsTypes.ConciergeRequest ||
          event.type === EventsTypes.Notice
        ) {
          return this.filters.includes(event.type);
        }
        return event;
      });
    },
    notifications() {
      return this.$store.state.notificationsModule.notificationsFamilyMember.reverse();
    },
    currentResidentServiceRequests(): ServiceRequest[] {
      return this.$store.state.additionalServicesModule.currentResidentServiceRequests.filter(
        service => {
          if (
            service.status == ServiceStatus.Approved ||
            service.status == ServiceStatus.AwaitingApproval
          ) {
            return service;
          }
        }
      );
    },
    notificationsResident(): Notification[] {
      return this.$store.state.notificationsModule.notifications;
    },
  },
}